import { MAX_TEAM_NAME_LEN } from "../../engine/replay";
import { LUCK_CALM, LUCK_CHAOS } from "../../data/tracks";
import { bind } from "../dom";
import { esc } from "../helpers";
import { t } from "../i18n";
import type { Screen, ScreenContext } from "./context";

/** Name the team and pick the run's modifiers (locked on a Daily), then draft. */
export function renderNaming(ctx: ScreenContext): Screen {
  const s = ctx.state.season!;
  const T = t();
  const html = `<div class="fade">
      <h2>${T.nameTitle}</h2>
      <p class="sub">${T.nameSub}</p>
      <input id="teamName" type="text" maxlength="${MAX_TEAM_NAME_LEN}" value="${esc(s.teamName)}" placeholder="${esc(T.namePlaceholder)}" style="width:100%;max-width:420px;display:block;margin-bottom:6px" />
      <p class="hint" style="margin-bottom:18px">${T.nameHint}</p>
      <div class="opts">
        ${
          s.daily
            ? `<p class="hint" style="margin:0">${T.dailyLocked(s.chaos)}</p>`
            : `<label class="opt"><input type="checkbox" id="optChaos" ${s.chaos ? "checked" : ""} />
          <span><b>${T.chaosMode}</b> <span class="hint" style="margin:0">${T.chaosDesc(Math.round(LUCK_CHAOS * 100), Math.round(LUCK_CALM * 100))}</span></span>
        </label>
        <label class="opt"><input type="checkbox" id="optMemory" ${s.fromMemory ? "checked" : ""} />
          <span><b>${T.memoryMode}</b> <span class="hint" style="margin:0">${T.memoryDesc}</span></span>
        </label>`
        }
      </div>
      <div style="margin-top:18px">
        <button class="btn primary" id="go">${T.startDrafting}</button>
        <button class="btn ghost" id="back">${T.back}</button>
      </div>
    </div>`;
  return {
    html,
    bind() {
      const input = document.getElementById("teamName") as HTMLInputElement | null;
      const chaosEl = document.getElementById("optChaos") as HTMLInputElement | null;
      const memEl = document.getElementById("optMemory") as HTMLInputElement | null;
      const submit = (): void =>
        ctx.actions.beginDraft(
          input?.value ?? "",
          s.daily ? s.chaos : (chaosEl?.checked ?? false),
          s.daily ? s.fromMemory : (memEl?.checked ?? false),
        );
      bind("go", "click", submit);
      bind("back", "click", ctx.actions.goMenu);
      input?.addEventListener("keydown", (e) => {
        if ((e as KeyboardEvent).key === "Enter") submit();
      });
      window.setTimeout(() => input?.focus(), 50);
    },
  };
}
